import { createContext, useReducer } from "react";
import AppReducer from './AppReducer';

const initialState = {
    transactions: [
        { id: 1, text: 'Flower', amount: -20, website: 'Flipkart.com', time: '11:45 AM' },
        { id: 2, text: 'Mobile', amount: -150, website: 'PhonePe', time: '09:28 AM' },
        { id: 3, text: 'Bank Transfer', amount: 1200, website: 'SBI', time: '12:15 PM' },
        { id: 4, text: 'Grocery', amount: -550, website: 'Big Basket', time: '12:48 PM' }
    ]
}

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AppReducer, initialState);

    function deleteTransaction(id) {
        dispatch({
            type: 'Delete_Transaction',
            payload: id
        })
    }

    function addItemTransaction(transaction) {
        dispatch({
            type: 'Add_Transaction',
            payload: transaction
        })
    }

    return (<GlobalContext.Provider value={{
        transactions: state.transactions,
        deleteTransaction,
        addItemTransaction
    }}> {children}
    </GlobalContext.Provider>)
}